import AuthNFallbackPolicyType, { formatAuthNFallbackPolicyForApi } from 'client/Security/AuthNFallbackPolicyType';
import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class AuthNFallbackPolicyApi extends CollectionApi {
  constructor(resource) {
    if (!resource || resource.length === 0) throw Error('AuthN Fallback requires a resource');

    super(`/api/v2/authn/policy/fallback/${resource}`, {
      skip: 0,
      limit: 1,
    });
    this.resource = resource;
  }

  async fetch(...args) {
    let res;

    try {
      res = await super.fetch(args);
    } catch (error) {
      // 404 - Not Found is default response
      // Ideally the API would return default effect by resource type
      // instead of a 404 error
      if (error.status === 404 && error.message === 'Not Found') {
        res = {};
      } else {
        return new AuthNFallbackPolicyType({});
      }
    }

    return new AuthNFallbackPolicyType({ ...res, resource: this.resource });
  }

  create(item) {
    const apiItem = formatAuthNFallbackPolicyForApi(item);
    return super.create(apiItem);
  }

  get(...args) {
    return this.fetch(args);
  }

  delete() {
    return axios.delete(this.baseUrl);
  }

  update(item) {
    const apiItem = formatAuthNFallbackPolicyForApi(item);
    return axios.put(this.baseUrl, apiItem).then((response = {}) => response.data);
  }
}

export default AuthNFallbackPolicyApi;
